const OutlinedInput = (theme) => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        sizeSmall: {
          input: {
            padding: '14px',
          },
        },
      },
    },
  };
};

export default OutlinedInput;
